import {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {RootState} from '../../../../setup'

const HeaderUserMenu: FC = () => {
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)

  const displayName =
    user?.firstname && user?.lastname
      ? `${user.firstname} ${user.lastname}`
      : user?.payload?.firstname && user?.payload?.lastname
      ? `${user.payload.firstname} ${user.payload.lastname}`
      : user?.username || 'Kullanıcı'

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-250px'
      data-kt-menu='true'
    >
      <div className='menu-item px-5'>
        <div className='menu-content d-flex align-items-center px-3'>
          <i className='bi bi-person-fill fs-3 me-3 text-dark' />
          <span className='fw-bold fs-5 text-uppercase'>{displayName}</span>
        </div>
      </div>

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <a href='/change-password' className='menu-link px-5 d-flex align-items-center'>
          <i className='bi bi-key me-3 text-muted fs-4' />
          Şifre Değiştir
        </a>
      </div>

      <div className='menu-item px-5'>
        <a
          href='/dashboard'
          className='menu-link px-5 d-flex align-items-center'
          onClick={(e) => {
            e.preventDefault()
            window.location.reload()
          }}
        >
          <i className='bi bi-arrow-repeat me-3 text-muted fs-4' />
          Yetkileri Yenile
        </a>
      </div>

      <div className='menu-item px-5'>
        <Link to='/logout' className='menu-link px-5 d-flex align-items-center'>
          <i className='bi bi-box-arrow-right me-3 text-muted fs-4' />
          Çıkış
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
